/* ============================================================
   Dravem — Ajout au panier AJAX + ouverture du tiroir natif Dawn
   ------------------------------------------------------------
   Les boutons « Ajouter au panier » des sections PDP (dravem-pdp-*)
   sont des LIENS permalink « /cart/<variantId>:<qty> » qui, par défaut,
   ajoutent le produit puis REDIRIGENT vers /cart (rechargement complet).
   Ce script intercepte ces liens, effectue l'ajout en AJAX, puis ouvre
   le tiroir natif de Dawn (cart-drawer.renderContents) — sans modifier
   aucune section PDP.
   - Actif uniquement si un <cart-drawer> est présent (mode tiroir).
   - Repli propre : en cas d'échec, on suit le lien permalink d'origine.
   Chargé depuis layout/theme.liquid (mode tiroir uniquement).
   ============================================================ */
(function () {
  'use strict';

  // Reconnaît un chemin permalink d'ajout : /cart/123:1  ou  /cart/123:1,456:2
  function parsePermalink(pathname) {
    var m = pathname.match(/^\/cart\/((?:\d+:\d+)(?:,\d+:\d+)*)\/?$/);
    if (!m) return null;
    return m[1].split(',').map(function (pair) {
      var p = pair.split(':');
      return { id: Number(p[0]), quantity: Number(p[1]) || 1 };
    });
  }

  function addUrl() {
    var base = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
    return base.slice(-3) === '.js' ? base : base + '.js';
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[href]');
    if (!link) return;

    var url;
    try { url = new URL(link.href, window.location.origin); } catch (_) { return; }

    var items = parsePermalink(url.pathname);
    if (!items) return; // pas un lien d'ajout → on laisse faire

    var cartDrawer = document.querySelector('cart-drawer');
    // Pas de tiroir (mode notification) → navigation native, on ne touche à rien
    if (!cartDrawer || typeof cartDrawer.renderContents !== 'function') return;

    // Lien désactivé (« Prochainement »/indispo) → ne rien faire
    if (link.getAttribute('aria-disabled') === 'true' || link.hasAttribute('disabled')) {
      e.preventDefault();
      return;
    }

    e.preventDefault();

    var sectionIds = (typeof cartDrawer.getSectionsToRender === 'function')
      ? cartDrawer.getSectionsToRender().map(function (s) { return s.id; })
      : ['cart-drawer', 'cart-icon-bubble'];

    link.classList.add('dv-atc--loading');

    fetch(addUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: sectionIds,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (res) {
        if (!res.ok || !res.data || !res.data.sections) {
          // Échec (rupture de stock, variante invalide…) → repli sur le permalink
          window.location.href = url.href;
          return;
        }
        // Le panier était peut-être VIDE au chargement de la page : l'élément
        // <cart-drawer> porte alors la classe `is-empty` (titre masqué, .drawer__inner
        // en grid centré). renderContents() ne remplace que #CartDrawer et NE retire PAS
        // cette classe de l'élément — Dawn le fait dans product-form.js, pas ici.
        // Sans ce retrait, le tiroir rempli hérite du CSS « panier vide » (header caché,
        // contenu centré → grand vide). On l'enlève donc, comme le thème natif.
        cartDrawer.classList.remove('is-empty');
        cartDrawer.renderContents(res.data); // remplit + ouvre le tiroir
      })
      .catch(function () {
        window.location.href = url.href;
      })
      .finally(function () {
        link.classList.remove('dv-atc--loading');
      });
  }, false);
})();

/* ============================================================
   Dravem — Carrousel d'avis du tiroir panier
   ------------------------------------------------------------
   Fait tourner les avis (.dv-proof-slide) toutes les X s et gère les puces.
   Interroge le DOM en direct à chaque tick → survit au re-rendu AJAX du
   tiroir (renderContents remplace #CartDrawer par innerHTML, ce qui
   n'exécuterait pas un <script> inline). Les avis sont éditables dans
   Personnaliser → Paramètres du thème → « Panier · Avis clients ».
   ============================================================ */
(function () {
  'use strict';
  var DELAY = 4500; // ms entre deux avis

  function setActive(carousel, idx) {
    var slides = carousel.querySelectorAll('.dv-proof-slide');
    var dots = carousel.querySelectorAll('.dv-proof-dot');
    if (!slides.length) return;
    idx = ((idx % slides.length) + slides.length) % slides.length;
    for (var i = 0; i < slides.length; i++) {
      slides[i].classList.toggle('is-active', i === idx);
    }
    for (var d = 0; d < dots.length; d++) {
      var on = d === idx;
      dots[d].classList.toggle('is-active', on);
      dots[d].setAttribute('aria-selected', on ? 'true' : 'false');
    }
    carousel.setAttribute('data-active', String(idx));
  }

  function tick() {
    var carousels = document.querySelectorAll('.dv-proof-carousel--multi');
    for (var c = 0; c < carousels.length; c++) {
      var cur = parseInt(carousels[c].getAttribute('data-active'), 10) || 0;
      setActive(carousels[c], cur + 1);
    }
  }

  // Clic sur une puce → avis correspondant
  document.addEventListener('click', function (e) {
    var dot = e.target.closest && e.target.closest('.dv-proof-dot');
    if (!dot) return;
    var carousel = dot.closest('.dv-proof-carousel');
    if (!carousel) return;
    setActive(carousel, parseInt(dot.getAttribute('data-i'), 10) || 0);
  }, false);

  setInterval(tick, DELAY);
})();
